"use client";

import React, {useEffect, useState} from "react";
import { SDialogFC, SDialogProps } from "@/Master/SDialogFC/SDialogFC";
import RouterMgr from "@/Core/RouterMgr";
import {useDialogMethods} from "@/Master/SDialogFC/useDialogMethods";
import {confJson} from "@/app/config/confJson";
import {DriveUtil} from "@/Master/DriveUtil";
import $http from "@/app/_api";
import {GameEntries} from "@/app/(pages)/home/homeData";
import Load from "@/app/_components/Load/Load";

interface LoginGuideDialogProps extends SDialogProps {}

export const LoginGuideDialogFC: React.FC<LoginGuideDialogProps> = (props) => {
    const { fcKey, isOpen, onClose } = props;
    const {openDialog, closeDialog } = useDialogMethods(fcKey);

    const [gcBonus, setGcBonus] = useState<number>(0);
    const [scBonus, setScBonus] = useState<number>(0);

    useEffect(() => {
        getGuideRewardInfo().then((data) => {
            const { gcBonus, scBonus } = data;
            setGcBonus(gcBonus);
            setScBonus(scBonus);
        })
    }, []);

    const onCloseDialog = () => {
        onClose?.();
        closeDialog();
    }

    const goToLogin = () => {
        onCloseDialog();
        RouterMgr.signup();
    };

    const getGuideRewardInfo =  async () => {
        const data = await $http.Rewards.getRewardsConfig({rewardSource: 103});
        return data;
    }

    return (
        <SDialogFC
            fcKey={fcKey}
            isOpen={isOpen}
            mode="Center"
            title={(
                <div style={{
                    fontSize:'0.45rem',
                    padding: '0.2rem 0.8rem',
                }}>Join <b style={{color:'#FFCA34'}}>{confJson.h5_app_name}</b> by signing up and claim your welcome bonus reward for </div>
            )}
            buttons={[
                {
                    label: "Sign Up",
                    onClick: goToLogin,
                    icon:(<img style={{width:'0.92rem',paddingRight:'0.2rem'}} src='/img/guide/icon_mail.webp'/>),
                    style: "greenBtn" },
            ]}
        >
            <div>
                <div style={{
                    width:'5.3rem',
                    margin: '-0.65rem auto 0 auto',
                }}>
                    <img src='/img/guide/login_guide_box.webp'/>
                </div>
                {
                    scBonus > 0 ? (<>
                        <div style={{
                            fontSize: '1.1rem',
                            color: '#FAEE31',
                            textAlign: 'center',
                            fontWeight: '700',
                            height: '1.1rem',
                        }}>{DriveUtil.ToGcString(gcBonus, true)}</div>
                        <div style={{
                            fontSize: '0.8rem',
                            color: '#55FF32',
                            textAlign: 'center',
                            fontWeight: '700',
                        }}>PUSH {DriveUtil.ToScString(scBonus, true)}</div>
                    </>) : <Load/>
                }
            </div>
        </SDialogFC>
    );
};
